import { MAP_TYPES } from '@deck.gl/carto';

const COUNTY_VISUALIZATIONS_SOURCE_ID = 'countyVisualizationsSource';

function source(socioeconomicFactor, countyId, property = 'year') {
  let data = '';

  let countyIdSplitted = countyId.split(',');

  let stateName = countyIdSplitted?.[1]?.trim() || '';
  let countyName = countyIdSplitted?.[0]?.trim() || '';

  if (property === 'year') {
    data = `
    SELECT
        year,
        ${socioeconomicFactor},
        broadband,
        statename,
        countyname
      FROM
        carto-dw-ac-cn5bemsi.shared.county_observations
      WHERE
        countyname = (
          SELECT
            countyname
          FROM
            carto-dw-ac-cn5bemsi.shared.county_geometries
          WHERE
            statename ="${stateName}" AND countyname ="${countyName}"
        ) AND
        statename = (
          SELECT
            statename
          FROM
            carto-dw-ac-cn5bemsi.shared.county_geometries
          WHERE
            statename = '${stateName}' AND countyname ="${countyName}"
        )
      ORDER BY
        year
  `;
  }

  return {
    id: COUNTY_VISUALIZATIONS_SOURCE_ID,
    type: MAP_TYPES.QUERY,
    connection: 'carto_dw',
    data,
    queryParameters: {
      socioeconomicFactor,
      stateName,
      property,
    },
  };
}

export default source;
